import React, { memo, useCallback, useEffect, useState } from 'react';
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from 'components/ui/select';
import { Label } from 'components/ui/label';

import { getAllTypes } from '@app/api';

interface Props {
  value: string | null;
  onChange: (value: string | null, name?: string) => void;
  name?: string;
}

const defaultOption = {
  label: 'Все',
  value: 'all',
};

function VehicleTypeSelect(props: Props) {
  const { onChange, name, value } = props;
  const [options, setOptions] = useState<{ label: string; value: string }[]>(
    []
  );

  const onChangeSelect = useCallback(
    (val: string) => {
      onChange(val === 'all' ? null : val, name);
    },
    [name, onChange]
  );

  const getData = useCallback(async () => {
    try {
      setOptions([]);
      const typesResponse = await getAllTypes();
      setOptions([
        defaultOption,
        ...typesResponse.map((type: string) => ({
          label: type,
          value: type,
        })),
      ]);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await getData();
    })();
  }, [getData]);

  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">ВИД ТЕХНИКИ</Label>
      <Select value={value ?? 'all'} onValueChange={onChangeSelect}>
        <SelectTrigger>
          <SelectValue placeholder="Выберите" />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export default memo(VehicleTypeSelect);
